import axios from './axiosInstances/axiosInstance';

const URI = '/restaurants';

export const getRestaurantById = (restaurantId) => {
  return axios.get(`${URI}/${restaurantId}`);
};
